/**
 * @deprecated since 3.4.10
 */
export class CustomMethod {
    name: string;
    method: any;
}
